// extracted by mini-css-extract-plugin
module.exports = {"container":"i_H4","image":"i_H5","wrapper":"i_H6","content":"i_H7","body":"i_H8","footer":"i_H9","action":"i_IA","title":"i_IB","label":"i_IC"};